// stubs.ts — placeholder data used until backend GraphQL resolvers are ready.
// When backend ships: uncomment the gql shells below, remove useState(STUB_*) calls
// in page components, and replace with useQuery / useMutation.

// import { gql } from '@apollo/client';
// export const GET_PORTAL_DEAL = gql`
//   query GetPortalDeal($dealId: ID!) {
//     deal(id: $dealId) {
//       id isSMSF activePhase buildStage propertyAddress
//       assignedStrategist { name role email phone }
//       assignedBroker { name role email phone }
//       assignedProjectCoordinator { name role email phone bookingUrl }
//       arrowwhiteContact { name role email phone }
//     }
//   }
// `;
// export const GET_PHASE_TASKS = gql`
//   query GetPhaseTasks($dealId: ID!, $phase: Int!) {
//     tasksByDeal(dealId: $dealId) {
//       id title status dueDate assignedToName isClientFacing isSMSFOnly
//       phase { phaseNumber }
//     }
//   }
// `;
// export const GET_PHASE_DOCUMENTS = gql`
//   query GetPhaseDocuments($dealId: ID!) {
//     documentsByDeal(dealId: $dealId) {
//       id title description status dueDate fileUrl rejectionReason
//     }
//   }
// `;
// export const GET_PHASE_CALLS = gql`
//   query GetScheduledCalls($dealId: ID!) {
//     scheduledCalls(dealId: $dealId) {
//       id title callType scheduledAt durationMinutes meetingUrl
//       assignedTo { firstName lastName }
//     }
//   }
// `;
// export const GET_BUILD_PHOTOS = gql`
//   query GetBuildPhotos($dealId: ID!) {
//     photosByDeal(dealId: $dealId) {
//       id stage caption fileUrl thumbnailUrl takenAt isPublished
//     }
//   }
// `;
// export const UPLOAD_DOCUMENT = gql`
//   mutation UploadDocument($documentId: ID!, $fileKey: String!, $fileUrl: String!) {
//     uploadDocument(documentId: $documentId, fileKey: $fileKey, fileUrl: $fileUrl) {
//       id status fileUrl
//     }
//   }
// `;
// export const UPLOAD_BUILD_PHOTO = gql`
//   mutation UploadBuildPhoto($input: BuildPhotoInput!) {
//     uploadBuildPhoto(input: $input) {
//       id stage caption fileUrl thumbnailUrl takenAt
//     }
//   }
// `;

import type {
  PortalDeal,
  PortalTask,
  PortalDocument,
  PortalCall,
  BuildPhoto,
} from './types';

export const STUB_DEAL: PortalDeal = {
  id: 'deal-001',
  isSMSF: false,
  activePhase: 2,
  buildStage: 'SLAB',
  propertyAddress: '14 Prosperity Drive, Ormeau QLD 4208',
  assignedStrategist: {
    name: 'James Hartley',
    role: 'Investment Strategist',
    email: 'james.hartley@onepropertyaustralia.com.au',
    phone: '0412 345 678',
    bookingUrl: 'https://calendly.com/james-hartley',
  },
  assignedBroker: {
    name: 'Sarah Chen',
    role: 'Finance Broker',
    email: 'sarah.chen@onepropertyaustralia.com.au',
    phone: '0423 456 789',
    bookingUrl: 'https://calendly.com/sarah-chen',
  },
  assignedProjectCoordinator: {
    name: 'Michael Torres',
    role: 'Project Coordinator',
    email: 'michael.torres@onepropertyaustralia.com.au',
    phone: '0434 567 890',
    bookingUrl: 'https://calendly.com/michael-torres',
  },
  arrowwhiteContact: {
    name: 'ArrowWhite Conveyancing',
    role: 'Conveyancing Solicitors',
    email: 'conveyancing@arrowwhite.com.au',
    phone: '07 3000 1234',
  },
};

// Phase 2 client-facing tasks (from spec section 5, Phase 2)
export const STUB_PHASE2_TASKS: PortalTask[] = [
  {
    id: 'p2-t1',
    title: 'ArrowWhite nominated as conveyancing solicitors',
    status: 'COMPLETE',
    assignedToName: 'James Hartley',
  },
  {
    id: 'p2-t2',
    title: 'Broker Fact Find — collect your financial details',
    status: 'COMPLETE',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t3',
    title: 'Lender Options Review — comparison prepared for you',
    status: 'COMPLETE',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t4',
    title: 'Contract Review — ArrowWhite reviews the contract',
    status: 'IN_PROGRESS',
    assignedToName: 'ArrowWhite',
    dueDate: '2026-05-20',
  },
  {
    id: 'p2-t5',
    title: 'Updated PIA presented to you',
    status: 'PENDING',
    assignedToName: 'James Hartley',
  },
  {
    id: 'p2-t6',
    title: 'Contracts signed',
    status: 'PENDING',
    assignedToName: 'James Hartley',
  },
  {
    id: 'p2-t7',
    title: 'Upload your signed contract',
    status: 'AWAITING_CLIENT',
    dueDate: '2026-05-25',
  },
  {
    id: 'p2-t8',
    title: 'Loan application submitted',
    status: 'PENDING',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t9',
    title: 'Conditional approval — we will notify you',
    status: 'PENDING',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t10',
    title: 'Formal approval — we will notify you',
    status: 'PENDING',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t11',
    title: 'Property purchase confirmed',
    status: 'PENDING',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t12',
    title: 'Land settlement complete',
    status: 'PENDING',
    assignedToName: 'ArrowWhite',
  },
  {
    id: 'p2-t13',
    title: 'Build deposit payment confirmed',
    status: 'PENDING',
    assignedToName: 'Sarah Chen',
  },
  {
    id: 'p2-t14',
    title: 'Meet your Project Coordinator',
    status: 'PENDING',
    assignedToName: 'James Hartley',
  },
];

export const STUB_PHASE2_DOCS: PortalDocument[] = [
  {
    id: 'doc-1',
    title: 'Signed Contract',
    description: 'Your signed property contract',
    status: 'REQUESTED',
    dueDate: '2026-05-25',
    isSMSFOnly: false,
  },
  {
    id: 'doc-2',
    title: 'Loan Application Supporting Documents',
    description: 'Payslips, tax returns, and bank statements',
    status: 'REQUESTED',
    dueDate: '2026-05-22',
    isSMSFOnly: false,
  },
  {
    id: 'doc-3',
    title: 'Identification (ID)',
    description: 'Passport or drivers licence — both sides',
    status: 'UPLOADED',
    isSMSFOnly: false,
  },
  {
    id: 'doc-4',
    title: 'Income Verification',
    description: 'Last 2 payslips or most recent tax return',
    status: 'APPROVED',
    isSMSFOnly: false,
  },
  {
    id: 'doc-5',
    title: 'SMSF Trust Deed',
    description: 'Your Self-Managed Super Fund trust deed',
    status: 'REQUESTED',
    dueDate: '2026-05-25',
    isSMSFOnly: true,
  },
];

export const STUB_PHASE2_CALLS: PortalCall[] = [
  {
    id: 'call-1',
    title: 'Broker Fact Find',
    callType: 'BROKER_FACT_FIND',
    scheduledAt: '2026-05-16T10:00:00',
    durationMinutes: 45,
    meetingUrl: 'https://teams.microsoft.com/meet/stub-link',
    hostName: 'Sarah Chen',
    hostRole: 'Finance Broker',
  },
  {
    id: 'call-2',
    title: 'Contract Review Walkthrough',
    callType: 'CONTRACT_REVIEW',
    scheduledAt: '2026-05-22T14:00:00',
    durationMinutes: 60,
    hostName: 'Sarah Chen + ArrowWhite',
    hostRole: 'Finance Broker',
  },
];

// Phase 3 client-facing tasks (from spec section 5, Phase 3)
export const STUB_PHASE3_TASKS: PortalTask[] = [
  {
    id: 'p3-t1',
    title: 'Build delivery commenced — Project Coordinator introduced',
    status: 'COMPLETE',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t2',
    title: 'Slab stage commenced',
    status: 'COMPLETE',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t3',
    title: 'Slab stage complete',
    status: 'COMPLETE',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t4',
    title: 'Frame stage commenced',
    status: 'IN_PROGRESS',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t5',
    title: 'Frame stage complete',
    status: 'PENDING',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t6',
    title: 'Roof stage commenced',
    status: 'PENDING',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t7',
    title: 'Roof stage complete — structure done',
    status: 'PENDING',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t8',
    title: 'Progress photos uploaded to your portal',
    status: 'COMPLETE',
    assignedToName: 'Michael Torres',
  },
  {
    id: 'p3-t9',
    title: 'Fortnightly progress check-in',
    status: 'IN_PROGRESS',
    assignedToName: 'Michael Torres',
    dueDate: '2026-05-21',
  },
];

// 3-4 photos per completed/active stage for realistic stub display
const now = new Date();
const daysAgo = (d: number) => new Date(now.getTime() - d * 86400000).toISOString();

export const STUB_PHASE3_PHOTOS: BuildPhoto[] = [
  // SLAB — complete
  {
    id: 'ph-1',
    stage: 'SLAB',
    caption: 'Slab pour underway — Week 2',
    fileUrl: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&q=70',
    takenAt: daysAgo(21),
  },
  {
    id: 'ph-2',
    stage: 'SLAB',
    caption: 'Slab complete — perimeter edge formed',
    fileUrl: 'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?w=800&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?w=400&q=70',
    takenAt: daysAgo(18),
  },
  {
    id: 'ph-3',
    stage: 'SLAB',
    caption: 'Slab cured and ready for framing',
    fileUrl: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=400&q=70',
    takenAt: daysAgo(14),
  },
  // FRAME — in progress (recent = "New")
  {
    id: 'ph-4',
    stage: 'FRAME',
    caption: 'Frame stage begun — wall frames going up',
    fileUrl: 'https://images.unsplash.com/photo-1590586767908-20d6d1b6db58?w=800&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1590586767908-20d6d1b6db58?w=400&q=70',
    takenAt: daysAgo(5),
  },
  {
    id: 'ph-5',
    stage: 'FRAME',
    caption: 'External wall framing 60% complete',
    fileUrl: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=800&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=400&q=70',
    takenAt: daysAgo(3),
  },
  // PLANNING — first photos
  {
    id: 'ph-6',
    stage: 'PLANNING',
    caption: 'Site cleared and ready for slab',
    fileUrl: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&q=70',
    takenAt: daysAgo(35),
  },
];

export const STUB_PHASE3_CALLS: PortalCall[] = [
  {
    id: 'call-p3-1',
    title: 'Fortnightly Build Progress Update',
    callType: 'BUILD_PROGRESS_UPDATE',
    scheduledAt: '2026-05-21T11:00:00',
    durationMinutes: 30,
    meetingUrl: 'https://teams.microsoft.com/meet/stub-build-update',
    hostName: 'Michael Torres',
    hostRole: 'Project Coordinator',
  },
];
